import { get, set } from 'lodash';

import { Expenses, StoreApplicant } from '@funnels/types';
import { FIELD_PATHS } from '@funnels/constants';

export function fixExpenses(expenses: Expenses, applicants: StoreApplicant[]) {
  const applicantClientId = get({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_APPLICANT_ID(0));

  // doesn't have a property
  if (!applicantClientId) {
    return;
  }

  const applicant = applicants.find((a) => a.clientId === applicantClientId);

  if (!applicants || !applicant?.id) {
    return;
  }

  const applicantId = applicant.id;

  // hydrated expenses have the same value for both id/clientId. It is therefore not necessary to do the mapping.
  // this only applies/fixes (server) id-less expenses who have been created but not hydrated (in the form state).
  if (applicantId && applicantId !== applicantClientId) {
    set({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_APPLICANT_ID(0), applicantId);
  }
}
